var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","width":"100%"},style:({ height: _vm.height }),attrs:{"id":"tract-visit-gpx-map-container"}},[_c('MapLayerControls',{attrs:{"map":_vm.map,"tract":_vm.tract,"layerCeiling":_vm.layerCeiling}}),_c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":_vm.mapId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }